import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { calculateTimeLeft } from "../../util/declarations/declarationUtils";
import { DateTime } from "luxon";
import { getTimeZoneFromSwaStation } from "../../util/timeZoneService";
import { DECLARATION_ROUND_CLOSED } from "../../util/messageConstants";

const DeclarationTimer = (props) => {
  const [startTimeLeft, setStartTimeLeft] = useState(calculateTimeLeft(props.windowDates[0], props.station));
  const [endTimeLeft, setEndTimeLeft] = useState(calculateTimeLeft(props.windowDates[1], props.station));

  useEffect(() => {
    const timer = setTimeout(() => {
      setStartTimeLeft(calculateTimeLeft(props.windowDates[0], props.station));
      setEndTimeLeft(calculateTimeLeft(props.windowDates[1], props.station));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  const renderDateAndTimes = (openCloseStatus, timeLeft) => {
    return (
      <div>
        <span>{"Declaration Round " + openCloseStatus + " in"} </span>
        <span>{timeLeft?.days.toLocaleString()} days, </span>
        <span>{timeLeft?.hours.toLocaleString()} hours, </span>
        <span>{timeLeft?.minutes.toLocaleString()} minutes, </span>
        <span>{timeLeft?.seconds.toLocaleString()} seconds</span>
      </div>
    );
  };

  const renderDeclarationTime = (startTimeLeft, endTimeLeft) => {
    const currentDateTime = DateTime.now().setZone(getTimeZoneFromSwaStation(props.station));
    const windowDateTimeBeforeDeclarationOpen = props.windowDates[0].minus({
      days: process.env.REACT_APP_ENABLE_DECLARATION_ROUND_YEAR_OPTION_PRIOR_TO_DECLARATION_OPEN,
    });

    // When past year is selected or
    // current year declaration window ended, then display close message
    if (
      props.windowDates[0].year === parseInt(props.selectedYear) ||
      currentDateTime.year > parseInt(props.selectedYear) ||
      (currentDateTime > props.windowDates[1] && currentDateTime.year + 1 === parseInt(props.selectedYear))
    ) {
      return <div>{DECLARATION_ROUND_CLOSED}</div>;
    } else if (currentDateTime > windowDateTimeBeforeDeclarationOpen && currentDateTime < props.windowDates[1]) {
      // Within declaration window and upcoming declaration year is selected
      if (!startTimeLeft && startTimeLeft !== undefined && endTimeLeft) {
        return <div>{renderDateAndTimes("closes", endTimeLeft)}</div>;
      } else if (startTimeLeft) {
        return <div>{renderDateAndTimes("opens", startTimeLeft)}</div>;
      }
    } else {
      return <></>; //Do not display declaration timer if year dropdown is not selected/ declaration is not yet ready to start
    }
  };

  return <div>{renderDeclarationTime(startTimeLeft, endTimeLeft)}</div>;
};

DeclarationTimer.propTypes = {
  windowDates: PropTypes.array.isRequired,
  station: PropTypes.string.isRequired,
  selectedYear: PropTypes.string.isRequired,
};

export default DeclarationTimer;
